
import { Vue, Component, Prop } from 'vue-property-decorator'
import Feedback from '@/types/feedback'
import TextEditor from '@/components/base/TextEditor.vue'

@Component({
  components: { TextEditor }
})

export default class FeedbackRequirements extends Vue {
  @Prop() feedback!: Feedback
  @Prop({ default: false, type: Boolean, required: false }) canEdit!: boolean
  @Prop({ default: false, type: Boolean, required: false }) canView!: boolean
  showEditor = false
  loading = false

  save () : void {
    this.$store.dispatch('saveFeedback', this.feedback)
    this.showEditor = false
  }
}
